// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/main.css';
import Global from '@/components/Global';
import Base from '@/assets/base.js';
import "babel-polyfill"

Vue.config.productionTip = false;

Vue.prototype.Global = Global;

Vue.use(ElementUI);
Vue.use(Base);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js